<template>
  <VModal :show="show" :title="title" type="small">
    <p class="mt-5">{{ text }}</p>

    <div class="flex gap-5 w-full mt-5">
      <VButton class="w-full bg-gray-500" @click="$emit('rejected')">لغو</VButton>
      <VButton class="w-full" @click="$emit('confirmed')">تایید</VButton>
    </div>
  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VButton from "@/components/General/VButton";

export default {
  name: "ModalConfirm",
  components: {VButton, VModal},
  props: ['show', 'title', 'text']
}
</script>

<style scoped>

</style>